import { BodyText, FlexColumn, FlexRow } from '@make-software/cspr-design';
import React, { useEffect, useState } from 'react';
import { PluginFormControlsProps } from 'app/components/management/common/plugins/form-control-map';
import { ErrorText, ErrorTextContainer, StyledInput } from 'app/components/common/common-styles';

export const RedirectFormControls = ({ metadata, errors, onChange }: PluginFormControlsProps) => {
  const [targetURL, setTargetURL] = useState('');
  const [secondsToClaim, setSecondsToClaim] = useState(15);

  useEffect(() => {
    if (!metadata) {
      onChange({ url: '', secondsToClaim: 15 });
      return;
    }

    setTargetURL(metadata.url);
    setSecondsToClaim(metadata.secondsToClaim);
    onChange({ url: metadata.url, secondsToClaim: metadata.secondsToClaim });
  }, [metadata]);

  const handleTargetURLChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setTargetURL(value);
    onChange({ url: value, secondsToClaim: secondsToClaim });
  };

  const handleSecondsToClaimChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const seconds = parseInt(value, 10) || 0;
    setSecondsToClaim(seconds);
    onChange({ url: targetURL, secondsToClaim: seconds });
  };

  return (
    <FlexColumn gap={12}>
      <StyledInput
        value={targetURL}
        label={<BodyText size={1}>Target URL</BodyText>}
        placeholder="https://example.com"
        onChange={handleTargetURLChange}
      />
      {errors?.pluginMetadata?.url && (
        <ErrorTextContainer justify={'flex-start'}>
          <ErrorText size={3}>{errors?.pluginMetadata?.url?.message}</ErrorText>
        </ErrorTextContainer>
      )}
      <StyledInput
        value={secondsToClaim.toString()}
        label={<BodyText size={1}>Seconds to claim</BodyText>}
        placeholder="15"
        onChange={handleSecondsToClaimChange}
      />
      {errors?.pluginMetadata?.secondsToClaim && (
        <ErrorTextContainer justify={'flex-start'}>
          <ErrorText size={3}>{errors?.pluginMetadata?.secondsToClaim?.message}</ErrorText>
        </ErrorTextContainer>
      )}
    </FlexColumn>
  );
};
